import PlaceholderImage from '@assets/images/Placeholder_Img.png';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox1,
  TextBox2,
  SectionContainer,
} from './BrandSuitabilityTwo.style';
import { useTranslation } from 'react-i18next';

const BrandSuitabilityTwo = () => {
  const { t } = useTranslation('brandSuitability');
  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>{t('brandSuitabilityTwo.title')}</h1>
        <StyledHr />
      </SectionWrapper>

      <ContentWrapper>
        <TextBox1>
          <div>
            <p>{t('brandSuitabilityTwo.subtitle')}</p>
          </div>
        </TextBox1>
        <TextBox2>
          <div className="grid-content">
            <h2>{t('brandSuitabilityTwo.paragraphOne.title')}</h2>
            <p>{t('brandSuitabilityTwo.paragraphOne.paragraph')}</p>
          </div>
          <div className="grid-content">
            <h2>{t('brandSuitabilityTwo.paragraphTwo.title')}</h2>
            <p>{t('brandSuitabilityTwo.paragraphTwo.paragraph')}</p>
          </div>
          <div className="grid-content">
            <h2>{t('brandSuitabilityTwo.paragraphThree.title')}</h2>
            <p>{t('brandSuitabilityTwo.paragraphThree.paragraph')}</p>
          </div>
          <div className="grid-content">
            <h2>{t('brandSuitabilityTwo.paragraphFour.title')}</h2>
            <p>{t('brandSuitabilityTwo.paragraphFour.paragraph')}</p>
          </div>
        </TextBox2>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default BrandSuitabilityTwo;
